var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeletePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2855 12.8574L12.8569 28.286V12.8574H28.2855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5322 28.061L13.05 28.5432L12.3682 27.8613L12.8503 27.3792L13.5322 28.061ZM15.4607 26.1325L14.4964 27.0968L13.8146 26.4149L14.7789 25.4506L15.4607 26.1325ZM17.3893 24.2039L16.425 25.1682L15.7432 24.4863L16.7075 23.522L17.3893 24.2039ZM19.3179 22.2753L18.3536 23.2396L17.6717 22.5578L18.636 21.5935L19.3179 22.2753ZM21.2464 20.3468L20.2822 21.311L19.6003 20.6292L20.5646 19.6649L21.2464 20.3468ZM23.175 18.4182L22.2107 19.3825L21.5289 18.7006L22.4932 17.7363L23.175 18.4182ZM25.1036 16.4896L24.1393 17.4539L23.4575 16.772L24.4217 15.8078L25.1036 16.4896ZM27.0322 14.561L26.0679 15.5253L25.386 14.8435L26.3503 13.8792L27.0322 14.561ZM28.4786 13.1146L27.9964 13.5967L27.3146 12.9149L27.7967 12.4328L28.4786 13.1146Z",
    fill: "#326FAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 12.375H28.2857V13.3393H13.3393V28.2857H12.375V12.375Z",
    fill: "#326FAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2857 11.5713C28.9959 11.5713 29.5714 12.1469 29.5714 12.857C29.5714 13.5671 28.9959 14.1427 28.2857 14.1427C27.5756 14.1427 27 13.5671 27 12.857C27 12.1469 27.5756 11.5713 28.2857 11.5713Z",
    fill: "#F3F6F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2859 12.0532C27.8421 12.0532 27.4824 12.4129 27.4824 12.8567C27.4824 13.3006 27.8421 13.6603 28.2859 13.6603C28.7298 13.6603 29.0895 13.3006 29.0895 12.8567C29.0895 12.4129 28.7298 12.0532 28.2859 12.0532ZM26.5181 12.8567C26.5181 11.8803 27.3095 11.0889 28.2859 11.0889C29.2623 11.0889 30.0538 11.8803 30.0538 12.8567C30.0538 13.8331 29.2623 14.6246 28.2859 14.6246C27.3095 14.6246 26.5181 13.8331 26.5181 12.8567Z",
    fill: "#326FAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8571 9C14.9876 9 16.7143 10.7267 16.7143 12.8571C16.7143 14.9876 14.9876 16.7143 12.8571 16.7143C10.7267 16.7143 9 14.9876 9 12.8571C9 10.7267 10.7267 9 12.8571 9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8574 9.48186C10.9932 9.48186 9.48235 10.9927 9.48235 12.8569C9.48235 14.721 10.9932 16.2319 12.8574 16.2319C14.7215 16.2319 16.2324 14.721 16.2324 12.8569C16.2324 10.9927 14.7215 9.48186 12.8574 9.48186ZM8.51807 12.8569C8.51807 10.4602 10.4606 8.51758 12.8574 8.51758C15.2541 8.51758 17.1966 10.4602 17.1966 12.8569C17.1966 15.2536 15.2541 17.1961 12.8574 17.1961C10.4606 17.1961 8.51807 15.2536 8.51807 12.8569Z",
    fill: "#326FAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2311 11.2304C11.4195 11.0422 11.7248 11.0422 11.9132 11.2304L14.484 13.8001C14.6723 13.9884 14.6723 14.2936 14.484 14.4818C14.2957 14.6701 13.9903 14.6701 13.802 14.4818L11.2311 11.9121C11.0428 11.7239 11.0428 11.4187 11.2311 11.2304Z",
    fill: "#326FAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4814 11.2307C14.6696 11.4191 14.6696 11.7245 14.4814 11.9129L11.9122 14.4843C11.724 14.6727 11.4189 14.6727 11.2307 14.4843C11.0425 14.2959 11.0425 13.9905 11.2307 13.8022L13.7998 11.2307C13.9881 11.0424 14.2932 11.0424 14.4814 11.2307Z",
    fill: "#326FAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.857 27C13.5671 27 14.1427 27.5756 14.1427 28.2857C14.1427 28.9959 13.5671 29.5714 12.857 29.5714C12.1469 29.5714 11.5713 28.9959 11.5713 28.2857C11.5713 27.5756 12.1469 27 12.857 27Z",
    fill: "#F3F6F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8572 27.4819C12.4133 27.4819 12.0536 27.8416 12.0536 28.2854C12.0536 28.7293 12.4133 29.089 12.8572 29.089C13.3011 29.089 13.6608 28.7293 13.6608 28.2854C13.6608 27.8416 13.3011 27.4819 12.8572 27.4819ZM11.0894 28.2854C11.0894 27.309 11.8808 26.5176 12.8572 26.5176C13.8336 26.5176 14.6251 27.309 14.6251 28.2854C14.6251 29.2619 13.8336 30.0533 12.8572 30.0533C11.8808 30.0533 11.0894 29.2619 11.0894 28.2854Z",
    fill: "#326FAE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePoint);
export default __webpack_public_path__ + "static/media/delete-point.aee75e10152d33820f11ff0883a59857.svg";
export { ForwardRef as ReactComponent };